import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActiveAgentService {

  constructor(private httpClient: HttpClient) {

  }

  getTaggingAttributes(accountId: number): Observable<ActiveAgentTaggingAttributes[]> {
    return this.httpClient.get<ActiveAgentTaggingAttributes[]>(`${environment.apiSegments}/active-agent/tagging-attributes/${accountId}`);
  }

  shareToAttribute(request: ShareToAttributeRequest): Observable<any | HttpErrorResponse> {
    return this.httpClient.post(`${environment.apiSegments}/active-agent/share-to-attribute`, request);
  }

  getAttributePrices(accountId: number, segmentId?: number): Observable<ActiveAgentAttributePriceModel[]> {
    return this.httpClient.get<ActiveAgentAttributePriceModel[]>(
      `${environment.apiSegments}/active-agent/shares/${accountId}/${segmentId}`);
  }
}

export interface ActiveAgentTaggingAttributes {
  id: number;
  name: string;
}

export interface ShareToAttributeRequest {
  accountId: number;
  segmentId: number;
  activeAgentAttributeId: number;
  cpmInCent?: number;
}

export interface ActiveAgentAttributePriceModel {
  id?: number;
  segmentId?: number;
  attributeName?: string;
  cpmInCent?: number;
}

export type ActiveAgentAttribute = {
  clientId: number,
  cost?: number,
};
